import { createContext, useState,useEffect } from "react";
import { firebaseFire} from './services/Firebase'
import { doc, addDoc,setDoc,getDoc,getDocs, query,collection,where} from 'firebase/firestore'

import {Partner} from './models/Partner';
export const PartnersContext = createContext();

export const PartnerProvider = ({ children }) => {
    const [partner, setPartner] = useState(new Partner());
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});
    useEffect( () => {

    },[partner]);


    const partnerRegister  = ()  => {
        const now= new Date();
        setPartner({...partner,fecha:now});
        const email_body = `
        <p>
            Gracias por querer ser parte de nuestra comunidad automotriz.
            En <b>RUSHTERS</b> no nos detenemos en la búsqueda constantemente
            de las mejores opciones y tecnologías para los amantes del mundo motor.
            Para poder registrarte, por favor <b>realiza el pago de 10UF</b> a la siguiente cuenta.
        </p>
        <p>
            <b>Banco Santander</b>
            <b>Nombre</b>: RUSHTERS SpA
            <b>Cuenta corriente número</b>: 89630770
            <b>RUT:</b> 77.691.577-7
            <b>Mail:</b> contacto@rushters.com
        </p>
        <p>
            Con esto, estarás disponible en nuestra APP móvil y te entregaremos acceso a la APP Web
            para que nuestros usuarios acudan a tu taller para realizar los servicios en sus vehículos.
            Una vez confirmado el pago, durante las 24 horas siguientes te será enviado un correo a este email
            con las credeenciales de acceso a nuestra app web: https://partners.rushters.com
        </p>
        ¡Bienvenidos!
        `;

        setDoc(doc(firebaseFire, 'partners', partner.rut.replaceAll(".", "").replace("-", "")),partner)
        .then((e) => {
            const email_obj = {
                to: partner.correo,
                message: {
                  subject: 'Bienvenido a RUSHTERS',
                  html: email_body,
                },
              };
            const emailColl = collection(firebaseFire, 'mail');
            addDoc(emailColl,email_obj)
            .then((e) => {
                console.log("success email");
            }).catch((err) => {
                 throw err;
            });



        }).catch((err) => {
            throw err;
        });
    }


    const rutExist = async () => {
        try {
            const docRef = doc(firebaseFire, "partners",  partner.rut.replaceAll(".", "").replace("-", ""));
            const snap = await getDoc(docRef);
            return snap.exists();
        } catch (error) {
            console.error("Error en rutExist:", error);
            throw error;
        }
    };


    const emailExist = async () => {
        try {
            const q = query(
                collection(firebaseFire, "partners"),
                where("correo", "==", partner.correo)
            );
            const docsSnap = await getDocs(q);
            return docsSnap.docs.length > 0;
        } catch (error) {
            throw error;
        }
    };

    const ContextProviderValues = {
        loading,
        error,
        partnerRegister,
        partner,
        setPartner,
        rutExist,
        emailExist,
    };

    return (
        <PartnersContext.Provider value={ContextProviderValues}>
            {children}
        </PartnersContext.Provider>
    )
}
